import { Injectable, inject } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastService } from 'src/app/services/toast.service';

@Injectable()
export class DatosGeograficosCementoUiEffectsService {
  private readonly toast = inject(ToastService);
  private readonly spinner = inject(NgxSpinnerService);

  syncLoading(isLoading: boolean): void {
    if (isLoading) {
      this.spinner.show();
      return;
    }
    this.spinner.hide();
  }

  showLoadError(): void {
    this.toast.showAdminError('No se pudieron cargar los datos geográficos.');
  }

  showCreateSuccess(): void {
    this.toast.showAdminSuccess('Registro creado correctamente.');
  }

  showCreateError(): void {
    this.toast.showAdminError('Error al crear el registro.');
  }

  showUpdateSuccess(): void {
    this.toast.showAdminSuccess('Registro actualizado correctamente.');
  }

  showUpdateError(): void {
    this.toast.showAdminError('Error al actualizar el registro.');
  }

  showDeleteSuccess(): void {
    this.toast.showAdminSuccess('Registro eliminado correctamente.');
  }

  showDeleteError(): void {
    this.toast.showAdminError('Error al eliminar el registro.');
  }

  showExcelSuccess(): void {
    this.toast.showAdminSuccess('Archivo recibido correctamente.');
  }

  showExcelError(): void {
    this.toast.showAdminError('Error al subir el archivo.');
  }
}
